<template>
  <div>
    <FITFormCard>
      <div slot="header">
        <b-row align-v="center" class="pb-2">
          <b-col cols="6">
            <span class="h5">{{ $t('adm.cpd.agentHeader') }}</span>
          </b-col>
          <b-col cols="6" class="text-right">
            <!-- <b-button variant="primary" size="md" @click="createTraining"><i class="fa fa-plus-circle mr-2"></i>{{ $t('adm.cpd.create.header') }}</b-button> -->
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable small ref="table" :filters="filters" :columns="columns" searchAction="getAgentTrainingList" vuexModule="CPD" type="training"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script>
import {
  FITSearchableTable,
  FITFormCard,
  FITModal,
  FITAlert
} from '@/components'

import moment from 'moment'

import {
  BulletinView
} from '@/Homepage/components'

import { mapGetters } from 'vuex'

import Vue from 'vue'

export default {
  name: 'AgentTrainingList',
  components: {
    FITSearchableTable,
    FITFormCard,
    BulletinView,
    FITModal,
    FITAlert
  },
  props: {
    isSuccess: {
      type: Boolean,
      default: null
    },
    alertContent: {
      type: String,
      default: null
    },
    alertVariant: {
      type: String,
      default: null
    }
  },
  mounted() {

  },
  methods: {

    getTranslated(type, key) {
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'CPD', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    }
  },

  computed: {
    ...mapGetters(['getTranslatedArray'])
  },
  data() {
    return {
      columns: [{
          key: 'ID',
          label: this.$t('adm.cpd.list.ID'),
          sortable: true,
          tdClass: ['cpd-ID']
        }, {
          key: 'agentCode',
          label: this.$t('adm.cpd.list.agentCode'),
          sortable: true,
          tdClass: ['cpd-agent-code']
        },
        {
          key: 'agentEnglishName',
          label: this.$t('adm.cpd.list.agentName'),
          sortable: true,
          tdClass: ['cpd-agent-name'],
          formatter: (row, key, item) => {
            return `${item.agentEnglishName}<br/>${item.agentChineseName}`;
          }
        }, {
          key: 'mpfCorePoint',
          label: this.$t('adm.cpd.list.mpfCorePoint'),
          tdClass: ['cpd-point']
        }, {
          key: 'mpfNonCorePoint',
          label: this.$t('adm.cpd.list.mpfNonCorePoint'),
          tdClass: ['cpd-point']
        }, {
          key: 'mpfPoint',
          label: this.$t('adm.cpd.list.mpfPoint'),
          tdClass: ['cpd-point']
        },
        {
          key: 'normalPoint',
          label: this.$t('adm.cpd.list.normalPoint'),
          tdClass: ['cpd-point']
        }
      ],

      filters: [{
          label: this.$t('general.startDate'),
          key: 'startDate',
          type: 'datetime',
          default: moment().format('YYYY-MM-DD')
        },
        {
          label: this.$t('general.endDate'),
          key: 'endDate',
          type: 'datetime',
          default: moment().add(1, 'year').format('YYYY-MM-DD')
        }
      ],
      form: {},
    }
  }
}

</script>
<style>
.cpd-ID {
  width: 100px;
}

.cpd-agent-code {
  width: 250px;
}

.cpd-agent-name {
  /*width: 650px;*/
}

.cpd-point {
  width: 200px;
}

</style>



// WEBPACK FOOTER //
// src/Adm/CPD/components/AgentTrainingList.vue